import React from 'react';
import { Dropdown, useClassNameMapper } from 'react-bootstrap';
import type { EmptyStateProps } from '../common/EmptyState/EmptyState';
import EmptyState from '../common/EmptyState/EmptyState';

type Props = Pick<EmptyStateProps, 'description' | 'title'>;

/**
 * Renders the empty state component for an advanced dropdown
 * @author Arjun Krishna, Soumen Porel, Rosalyn Rowe
 */
const AdvancedDropdownEmptyStateItem: React.FC<Props> = ({ description, title }) => {
  const cx = useClassNameMapper();

  return (
    <Dropdown.Item disabled as="div">
      <EmptyState className={cx('px-0')} description={description} title={title} />
    </Dropdown.Item>
  );
};

export default AdvancedDropdownEmptyStateItem;
